export type WidgetSize = "sm" | "md" | "lg";

const widgetScript = document.getElementById("fuzey-widget");
const params = new URLSearchParams(window.location.search);

const getAttribute = (name: string) => widgetScript?.getAttribute(name) || null;

export const merchant_id =
    getAttribute("widget-id") ||
    params.get("widget-id") || // applicable only for widget.fuzey.io for testing purposes
    "";
export const preview_mode = getAttribute("preview-mode") === "true";
export const primary_colour = getAttribute("primary-colour");
export const secondary_colour = getAttribute("secondary-colour");
export const success_title = getAttribute("success-title");
export const hide_contact_form = getAttribute("hide-contact-form");
export const success_subtitle = getAttribute("success-subtitle");
export const button_image_url = getAttribute("button-image-url");
export const external_contact_form = getAttribute("external-contact-form");
export const logo_base64 = getAttribute("logo-base64");
export const extra_margin_bottom = Number(getAttribute("extra-margin-bottom")) || 0;
export const extra_margin_right = Number(getAttribute("extra-margin-right")) || 0;

const sizeAttribute = getAttribute("size");
export const widget_size = sizeAttribute
    ? (sizeAttribute as WidgetSize)
    : undefined;
